import React from "react";
import { createUseStyles } from "react-jss";
import { DropdownOptions, ListCell } from "../..";
import { OverlayStyle, OverlayTrigger } from "../../OverlayTrigger";
import { THEME } from "../../theming/theming";
import { classNames } from "../../utils/classNames";
import { isDefined } from "../../utils/isDefined";
import { TableDropdownAction } from "../TableDropdown";
import { getCellDataId, getCellDataTestId } from "../tableUtils";
import { RowChevron } from "./RowChevron";
import { getCellLinkProps, getBoolValueFromRow } from "./utilsV2Table";
import { v4 as uuidv4 } from "uuid";
export function TableRowAction(props) {
    var item = props.item, dropdown = props.dropdown, rowIndex = props.rowIndex;
    var classes = useTableActionClasses(props);
    var tableHasDropdown = isDefined(props === null || props === void 0 ? void 0 : props.dropdown);
    var rowIsDisabled = getBoolValueFromRow(item, props.disabledRows);
    var cellLink = getCellLinkProps(item, props === null || props === void 0 ? void 0 : props.link, props === null || props === void 0 ? void 0 : props.onSelect, props.linkBuilder);
    var cellDataId = getCellDataId(rowIndex, props === null || props === void 0 ? void 0 : props.dataId);
    var cellDataTestId = getCellDataTestId(rowIndex, props === null || props === void 0 ? void 0 : props.dataTestId);
    var handleOptionSelection = function (option, item) {
        option.onClick && option.onClick(item);
    };
    var uniqueId = uuidv4();
    var numberOfColumns = props === null || props === void 0 ? void 0 : props.headings.length;
    var colIndex = props.drawer ? numberOfColumns + 2 : numberOfColumns + 1;
    return (React.createElement(ListCell, { className: classNames("table-listRowAction", tableHasDropdown ? classes.dropdown : classes.arrow, classes.action), ariaColIndex: colIndex, role: "cell", link: !rowIsDisabled && !dropdown ? cellLink : undefined, dataId: cellDataId && "".concat(cellDataId, "-action"), dataTestId: cellDataTestId && "".concat(cellDataTestId, "-action"), dataHook: "table-dropdown" }, dropdown ? (React.createElement(OverlayTrigger, { overlayTrigger: React.createElement(TableDropdownAction, { id: uniqueId, haspopup: true, dataId: cellDataId, dataTestId: cellDataTestId }), placement: "bottom-end", overlayContent: React.createElement(DropdownOptions, { options: dropdown, id: cellDataTestId !== null && cellDataTestId !== void 0 ? cellDataTestId : "", item: item, onChange: function (option, _ev, item) {
                return handleOptionSelection(option, item);
            } }), triggerType: "click", overlayStyle: OverlayStyle.Dropdown })) : (React.createElement(RowChevron, { disabled: rowIsDisabled }))));
}
export function useTableActionClasses(props) {
    var useStyles = createUseStyles({
        dropdown: {
            "& .list__cell--value": {
                verticalAlign: "top",
                backgroundColor: "transparent",
            },
            "& .menu": {
                position: "relative",
                "& .btn-dropdown-menu": {
                    float: "right",
                },
            },
        },
        arrow: {
            paddingLeft: "7.5px!important",
        },
        action: {
            gridArea: (props === null || props === void 0 ? void 0 : props.childTable) ? "unset" : "data-action",
            paddingTop: (props === null || props === void 0 ? void 0 : props.dropdown) ? 0 : 2,
            paddingRight: "0px!important",
            backgroundColor: "transparent",
            borderLeft: (props === null || props === void 0 ? void 0 : props.drawer) || (props === null || props === void 0 ? void 0 : props.childTable)
                ? {}
                : [1, "solid", THEME.palette.gray.cloud.color],
            minHeight: 30,
            width: 32,
        },
    });
    return useStyles();
}
